import Styles from './Questionnair.module.scss'
import { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { ViewContext } from 'components/lib'


export function Questionnaire({ showQuestionnaire, setShowQuestionnaire, endpoint, redirect }) {
    const navigate = useNavigate();
    const context = useContext(ViewContext)
    const [disableSubmit, setDisableSubmit] = useState(true)



    const [questions, setQuestions] = useState([
        {
            "question": "How many years of work experience do you have with the relevant skills?",
            "type": "number",
            "answer": ''
        },
        {
            "question": "What is your current notice period (in months)?",
            "type": "number",
            "answer": ''
        },
        {
            "question": "Please state your Expected CTC (LPA)",
            "type": "select",
            "options": ["0-5 LPA", "5-10 LPA", "10-15 LPA", "15-20 LPA", "20-25 LPA", "Above 25 LPA"],
            "answer": ''
        },
        {
            "question": "Willing to work from office/hybrid?",
            "type": "radio",
            "options": ["Yes", "No"],
            "answer": ''
        },
        {
            "question": "Willing to relocate?",
            "type": "radio",
            "options": ["Yes", "No"],
            "answer": ''
        },

    ])

    useEffect(() => {
        const allAnswersFilled = questions.every((ques) => ques.answer !== '');
        if (allAnswersFilled) {
            setDisableSubmit(false)
        } else {
            setDisableSubmit(true)
        }
        // eslint-disable-next-line no-use-before-define
    }, [questions])

    const handleInputChange = (index, value) => {
        const updatedQuestions = [...questions];
        updatedQuestions[index].answer = value;
        setQuestions(updatedQuestions);
    };

    const submitQuestionnaire = () => {
        try {

            const options = {
                method: "POST",
                url: endpoint,
                headers: {
                    "accept": "application/json",
                },
                data: {
                    ques: questions
                }
            };
            axios
                .request(options)
                .then((response) => {
                    if (response.status === 204) {
                        setShowQuestionnaire(!showQuestionnaire)
                        context.notification.show("Applied successfully", 'success', true)

                        navigate(`${redirect}`)

                    } else {
                        context.notification.show("There was an error in submitting your application - Please try again", 'error')
                    }
                })
                .catch((err) => {
                    console.log(err.response);
                    context.notification.show("There was an error in submitting your application", 'error')

                });

        } catch (error) {
            console.log("error", error);
            context.notification.show("There was an error in submitting your application", 'error')

        }
    }


    return (
        <div className={Styles.ancestorContainer} >
            {
                questions?.map((ques, index) => {
                    return (
                        <div key={ques.question}>
                            <p className={Styles.question}>{ques.question}<span style={{ color: "red", marginLeft: '0.15em' }}>*</span></p>
                            {
                                ques.type === "number" ?
                                    <input
                                        type='number'
                                        className={Styles.numberInput}
                                        onChange={(e) => handleInputChange(index, e.target.value)}
                                    />
                                    : ques.type === "select" ?
                                        <div className={Styles.radioContainer}>
                                            <select className={Styles.select} onChange={(e) => { handleInputChange(index, e.target.value) }}>
                                                <option value=''>Select An Option</option>
                                                {
                                                    ques.options.map((option, optIndex) => {

                                                        return <option className={Styles.selectOption} key={`${ques.question}-${option}`} value={option}>{option}</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                        :
                                        <div className={Styles.radioContainer}>
                                            {ques.options.map((option, optIndex) => {
                                                return (
                                                    <div key={`${ques.question}-${option}`} className={Styles.radioInput}>
                                                        <input
                                                            type='radio'
                                                            value={option}
                                                            name={ques.question}
                                                            className={Styles.radioBtn}
                                                            onChange={() => handleInputChange(index, option)}
                                                        />
                                                        <label>{option}</label>

                                                    </div>
                                                )
                                            })}
                                        </div>
                            }

                        </div>
                    )
                })
            }
            <div className={Styles.buttonContainer}>
                <button
                    className={Styles.cancelBtn}
                    onClick={() => setShowQuestionnaire(!showQuestionnaire)}
                >
                    Cancel
                </button>
                <button
                    disabled={disableSubmit}
                    className={Styles.submitBtn}
                    onClick={() => {
                        submitQuestionnaire();
                    }}
                >
                    Submit
                </button>
            </div>
        </div>
    )
}